import { render, staticRenderFns } from "./pt-upload-big-file.vue?vue&type=template&id=616c30c0&"
import script from "./pt-upload-big-file.vue?vue&type=script&lang=js&"
export * from "./pt-upload-big-file.vue?vue&type=script&lang=js&"
import style0 from "./pt-upload-big-file.vue?vue&type=style&index=0&id=616c30c0&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports